import { useEffect, useState } from "react";
import { GraduationCap, Users, Presentation, Receipt, CreditCard, TrendingUp, TrendingDown, Scale, AlertCircle } from "lucide-react";
import api from "../lib/api";
import { PageHeader, fmt } from "../components/bits";

const CARDS = [
  { key: "students_active", label: "Estudiantes activos", icon: GraduationCap, color: "text-blue-700 bg-blue-50" },
  { key: "guardians", label: "Padres/Tutores", icon: Users, color: "text-sky-700 bg-sky-50" },
  { key: "teachers", label: "Maestros", icon: Presentation, color: "text-indigo-700 bg-indigo-50" },
  { key: "pending_invoices", label: "Facturas pendientes", icon: Receipt, color: "text-rose-700 bg-rose-50" },
  { key: "review_payments", label: "Pagos en revisión", icon: CreditCard, color: "text-amber-700 bg-amber-50" },
];

export default function Dashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/dashboard/stats").then((r) => setStats(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="dashboard-page">
      <PageHeader title="Dashboard" subtitle="Resumen general del colegio" />
      {!stats ? (
        <p className="text-slate-400 text-sm">Cargando…</p>
      ) : (
        <>
          <div className="grid grid-cols-2 lg:grid-cols-5 gap-4 mb-6">
            {CARDS.map((c) => (
              <div key={c.key} className="bg-white border border-slate-200 rounded-xl p-5 shadow-sm" data-testid={`stat-${c.key}`}>
                <div className={`w-9 h-9 rounded-lg flex items-center justify-center mb-3 ${c.color}`}>
                  <c.icon className="w-4 h-4" />
                </div>
                <p className="text-2xl font-bold text-slate-900">{stats[c.key]}</p>
                <p className="text-xs text-slate-500 mt-0.5">{c.label}</p>
              </div>
            ))}
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
            <div className="bg-white border border-slate-200 rounded-xl p-5 shadow-sm" data-testid="stat-income">
              <div className="flex items-center gap-2 text-emerald-700 mb-2"><TrendingUp className="w-4 h-4" /><span className="text-xs font-semibold uppercase tracking-wider">Ingresos</span></div>
              <p className="text-xl font-bold text-slate-900">{fmt(stats.total_income)}</p>
            </div>
            <div className="bg-white border border-slate-200 rounded-xl p-5 shadow-sm" data-testid="stat-expenses">
              <div className="flex items-center gap-2 text-rose-700 mb-2"><TrendingDown className="w-4 h-4" /><span className="text-xs font-semibold uppercase tracking-wider">Gastos</span></div>
              <p className="text-xl font-bold text-slate-900">{fmt(stats.total_expenses)}</p>
            </div>
            <div className="bg-white border border-slate-200 rounded-xl p-5 shadow-sm" data-testid="stat-balance">
              <div className={`flex items-center gap-2 mb-2 ${stats.balance < 0 ? "text-rose-700" : "text-blue-800"}`}><Scale className="w-4 h-4" /><span className="text-xs font-semibold uppercase tracking-wider">Balance</span></div>
              <p className={`text-xl font-bold ${stats.balance < 0 ? "text-rose-600" : "text-slate-900"}`}>{fmt(stats.balance)}</p>
            </div>
            <div className="bg-white border border-slate-200 rounded-xl p-5 shadow-sm" data-testid="stat-receivable">
              <div className="flex items-center gap-2 text-amber-700 mb-2"><AlertCircle className="w-4 h-4" /><span className="text-xs font-semibold uppercase tracking-wider">Por cobrar</span></div>
              <p className="text-xl font-bold text-slate-900">{fmt(stats.receivable)}</p>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
